import { MARQUEE_WORDS } from "@/lib/site";

export default function Marquee() {
  const words = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section className="relative z-10 overflow-hidden border-y border-white/10 py-10 md:py-14">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {words.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 md:mx-12">
            <span className="font-display text-4xl italic text-cream/90 md:text-6xl">{w}</span>
            <span className="text-2xl text-gold md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
